import React from 'react'
import ListItem from "../presents/ListItem"

const ListItemNoDataContainer = ({
    onDelete
}) => {
    return <ListItem
        titleTransId="program_no_movie_found"
        onDelete={onDelete}
    />
}

export default ListItemNoDataContainer